import { useNavigate, useParams } from "react-router-dom";
import CanvasMap from "../components/global/CanvasMap";
import { useEffect, useState } from "react";
import Load from "../components/ingka/Load";
import { useCanvasStore } from "../store/canvasStore";
import { useMap } from "../hooks/use-map";
import useCanvasSizing from "../hooks/useCanvasSizing";

export default function Map() {
  const navigate = useNavigate();
  const { mapId } = useParams();
  const [canvasSize, setCanvasSize] = useState();
  const [canvasMap, setCanvasMap] = useState(null);
  const { maps } = useCanvasStore();
  const { map, refetchMap, isLoadingMap } = useMap(mapId);
  const { calculateCanvasSize } = useCanvasSizing();

  useEffect(() => {
    if (map) {
      const image = maps.find((map) => map.id === parseInt(mapId)).image;
      if (image !== undefined) {
        map.image = image;
        map.addons = map.markers.map((marker) => ({
          ...marker,
          isMarker: true,
        }));
        setCanvasMap(map);
        setCanvasSize(calculateCanvasSize(map.width, map.height));
      } else {
        //if there is no map image, return to maps
        navigate("maps");
      }
    }
  }, [map, canvasMap, maps, mapId, navigate]);

  return (
    <>
      {isLoadingMap && <Load />}
      {canvasMap && canvasSize && (
        <CanvasMap
          type="map"
          map={canvasMap}
          canvasSize={canvasSize}
          backgroundSize="contain"
          backgroundPosition="center"
          getData={refetchMap}
          level={0}
        />
      )}
    </>
  );
}
